import React from 'react';

const PrivacyPolicy: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl text-white">
      <div className="bg-black/40 border border-gold-500/20 rounded-lg shadow-gold p-6 lg:p-8">
        <h1 className="text-4xl font-display text-gold-500 mb-8">Privacy Policy</h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Introduction</h2>
          <p className="mb-4 text-gray-300">
            Welcome to Divine Intelligence. We respect your privacy and are committed to protecting your personal data.
            This privacy policy explains how we collect, use, and safeguard your information when you use our application.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Information We Collect</h2>
          <p className="mb-4 text-gray-300">When you use Divine Intelligence, we collect:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-300 space-y-2">
            <li>Basic profile information (name, email) from your Google account when you sign in</li>
            <li>Your preferences and settings within the application</li>
            <li>Notes and annotations you create while using the application</li>
            <li>Usage data to improve our services</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">How We Use Your Information</h2>
          <p className="mb-4 text-gray-300">We use your information for:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-300 space-y-2">
            <li>Providing and maintaining our services</li>
            <li>Personalizing your experience with scripture insights and recommendations</li>
            <li>Communicating with you about your account or our services</li>
            <li>Improving our application and user experience</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Data Storage and Security</h2>
          <p className="mb-4 text-gray-300">
            We use Supabase for secure data storage and authentication. All data is encrypted in transit and at rest.
            We implement appropriate security measures to protect your personal information and spiritual journey data.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Google Sign-In Data Usage</h2>
          <p className="mb-4 text-gray-300">
            When you sign in with Google, we only access basic profile information necessary for authentication.
            We follow Google's Limited Use requirements and do not:
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-300 space-y-2">
            <li>Transfer this information to others unless necessary to provide our service</li>
            <li>Use the information for serving advertisements</li>
            <li>Store your Google credentials</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Your Rights</h2>
          <p className="mb-4 text-gray-300">You have the right to:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-300 space-y-2">
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-display text-gold-400 mb-4">Contact Us</h2>
          <p className="mb-4 text-gray-300">
            If you have any questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:divineintelligenceapp@gmail.com" className="text-gold-500 hover:text-gold-400 underline">
              divineintelligenceapp@gmail.com
            </a>
          </p>
        </section>

        <div className="text-sm text-gray-400 border-t border-gold-500/20 pt-4 mt-8">
          <p>Last updated: January 19, 2025</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
